import styled from "styled-components";

export const DotsLoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;